/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

// A short tick on touch screens when a control is pressed, so taps are felt as
// well as seen. Touch only (a mouse click never vibrates), throttled, and off
// switch in Settings. The wall display (/hub) has its own haptics.

const KEY = "nyrvex-ui-haptics";
const TARGETS = 'button, a[href], [role="button"], [role="tab"], [role="switch"], [role="menuitem"], [role="checkbox"], [role="radio"], summary, label[for]';

export const uiHapticsSupported = (): boolean => typeof navigator !== "undefined" && typeof navigator.vibrate === "function";

export function uiHapticsEnabled(): boolean {
  try {
    return localStorage.getItem(KEY) !== "off";
  } catch {
    return true;
  }
}

export function setUiHaptics(on: boolean): void {
  try {
    localStorage.setItem(KEY, on ? "on" : "off");
  } catch {
    /* ignore */
  }
  if (on && uiHapticsSupported()) navigator.vibrate(12); // let the user feel what it is
}

export function installUiFeedback(): void {
  if (typeof document === "undefined" || !uiHapticsSupported()) return;
  let last = 0;
  document.addEventListener(
    "pointerdown",
    (e) => {
      if (e.pointerType !== "touch" || !uiHapticsEnabled()) return;
      const el = (e.target as Element | null)?.closest?.(TARGETS) as HTMLElement | null;
      if (!el || (el as HTMLButtonElement).disabled || el.getAttribute("aria-disabled") === "true") return;
      if (el.closest(".hub")) return;
      const now = performance.now();
      if (now - last < 60) return;
      last = now;
      navigator.vibrate(7);
    },
    { passive: true, capture: true },
  );
}
